'use client'

import { cx } from './utils/cx'

interface SearchFieldProps {
  value?: string
  onChange?: (value: string) => void
  placeholder?: string
  block?: boolean
  onClear?: () => void
  autoFocus?: boolean
  className?: string
}

export function SearchField({
  value,
  onChange,
  placeholder = 'Search…',
  block,
  onClear,
  autoFocus,
  className
}: SearchFieldProps) {
  return (
    <div className={cx('st-search', block && 'block', className)}>
      <span className="glass" aria-hidden="true" />
      <input
        type="text"
        value={value ?? ''}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
      />
      {value && (onClear || onChange) && (
        <button
          type="button"
          className="clear"
          onClick={() => {
            if (onClear) onClear()
            else onChange?.('')
          }}
          aria-label="Clear search">
          ×
        </button>
      )}
    </div>
  )
}
